import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

/**
 * @component BulkActions
 * @description Componente que muestra acciones en lote (bulk actions) para aplicar a varios elementos seleccionados en una tabla.
 * Incluye un selector de acción (como exportar o eliminar) y un botón para aplicar la acción seleccionada.
 * 
 * **Nota:** Actualmente ambas opciones usan el mismo valor (`value="delete"`). Esto puede corregirse si se desea que sean diferentes.
 *
 * @returns {JSX.Element} Controles de acciones masivas.
 * 
 * @example
 * <BulkActions />
 */
const BulkActions = ({ onBulkAction }) => {
    const [selectedAction, setSelectedAction] = useState('');

    const handleChange = (e) => {
        setSelectedAction(e.target.value);
    };

    const handleApply = () => {
        if (selectedAction && onBulkAction) {
            onBulkAction(selectedAction);
        }
    };

    return (
        <div className="d-flex">
            <Form.Select size="sm" aria-label="Bulk actions"  onChange={handleChange}>
                <option>Acciones</option>
                <option value="export">Exportar</option>
               
            </Form.Select>
            <Button type="button" variant="falcon-default" size="sm" className="ms-2" onClick={handleApply}>
                Aplicar
            </Button>
        </div>
    )
}

export default BulkActions;